import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlugCircleXmark} from "@fortawesome/free-solid-svg-icons";

export const Unauthorized = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <FontAwesomeIcon icon={faPlugCircleXmark} size="6x" />
            <br /> <br />
            <h1>Acceso No Autorizado</h1>
            <h1>401</h1>
            <p>No tienes permiso para acceder a esta página.</p>
        </div>
    );
}